import { render } from "./swipeButton.vue?vue&type=template&id=6a5c4038&scoped=true"
import script from "./swipeButton.vue?vue&type=script&lang=js"
export * from "./swipeButton.vue?vue&type=script&lang=js"

import "./swipeButton.vue?vue&type=style&index=0&id=6a5c4038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5c4038"]])

export default __exports__